// Home page slider
(function () {
    const homeSlider = document.querySelector(`#slider-home`);

    if (homeSlider) {
        const slider = homeSlider.querySelector(`.swiper`);
        const buttonNext = homeSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = homeSlider.querySelector(`.swiper__button--prev`);

        const reviewsSwiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 4000,
            },
            speed: 1200,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
        });
    }
})();

// Home page catalog sliders
(function () {
    const sliders = document.querySelectorAll(`.slider-section`);

    sliders.forEach( (sectionSlider) => {
        const slider = sectionSlider.querySelector(`.swiper`);
        const buttonNext = sectionSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = sectionSlider.querySelector(`.swiper__button--prev`);
        const pagination = sectionSlider.querySelector(`.swiper-pagination`);

        const sectionSwiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 54,
            loop: true,
            breakpoints: {
                426: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    loop: false
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    loop: false
                }
            },
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            pagination: {
                el: pagination,
                clickable: true
            }
        });
    });
})();

// Famous reviews slider
(function () {
    const famousReviewsSlider = document.querySelector(`.famous-reviews__slider`);

    if (famousReviewsSlider) {
        const slider = famousReviewsSlider.querySelector(`.swiper`);
        const buttonNext = famousReviewsSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = famousReviewsSlider.querySelector(`.swiper__button--prev`);

        const reviewsSwiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
            updateOnWindowResize: true,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                    updateOnWindowResize: true,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                    updateOnWindowResize: true,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 35,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                    updateOnWindowResize: true,
                }
            },
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
        });
    }
})();

// Users review slider
(function () {
    const usersReviewSlider = document.querySelector(`.users-reviews__slider`);

    if (usersReviewSlider) {
        const slider = usersReviewSlider.querySelector(`.swiper`);
        const buttonNext = usersReviewSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = usersReviewSlider.querySelector(`.swiper__button--prev`);

        const reviewSwiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 55,
                    autoHeight: false,
                    observer: true,
                    observeParents: true,
                }
            },
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
        });
    }
})();

// Nozzles slider
(function () {
    const TABLET_LANDSCAPE_WIDTH = 1024;
    const nozzlesSlider = document.querySelector(`.nozzles__slider`);

    if (nozzlesSlider) {
        const slider = nozzlesSlider.querySelector(`.swiper`);

        let nozzlesSwiper;
        const initSwiper = () => {
            if (nozzlesSwiper) {
                return;
            }

            nozzlesSwiper = new Swiper(slider, {
                slidesPerView: 1.5,
                spaceBetween: 23,
                loop: false,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                    },
                    568: {
                        slidesPerView: 2.5,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                }
            });
        };

        const destroySwiper = () => {
            if (nozzlesSwiper) {
                nozzlesSwiper.destroy(true, true);
                nozzlesSwiper = undefined;
            }
        };

        const setSwiper = () => {
            if (window.innerWidth < TABLET_LANDSCAPE_WIDTH) {
                initSwiper();
            } else {
                destroySwiper();
            }
        };

        window.addEventListener(`resize`, setSwiper);

        setSwiper();
    }
})();

// Photo gallery slider
(function () {
    const priceSlider = document.querySelector(`.price__slider`);

    if (priceSlider) {
        const mainSlider = priceSlider.querySelector(`.swiper--main`);
        const buttonNext = priceSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = priceSlider.querySelector(`.swiper__button--prev`);
        const previewSlider = priceSlider.querySelector(`.swiper--preview`);

        const previewSwiper = new Swiper(previewSlider, {
            loop: false,
            spaceBetween: 30,
            slidesPerView: 3.5,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                },
                1024: {
                    slidesPerView: 6,
                },
                1200: {
                    slidesPerView: 5,
                },
            }
        });

        const mainSwiper = new Swiper(mainSlider, {
            loop: false,
            spaceBetween: 30,
            effect: `fade`,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            thumbs: {
                swiper: previewSwiper,
            },
        });
    }
})();

// Marketplaces slider
(function () {
    const marketplacesSlider = document.querySelector(`.marketplaces__slider`);

    if (marketplacesSlider) {
        const slider = marketplacesSlider.querySelector(`.swiper`);
        const buttonNext = marketplacesSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = marketplacesSlider.querySelector(`.swiper__button--prev`);

        const marketplacesSwiper = new Swiper(slider, {
            slidesPerView: 2,
            grid: {
                rows: 2,
                fill: `row`,
            },
            spaceBetween: 15,
            watchSlidesProgress: true,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            breakpoints: {
                600: {
                    grid: {
                        rows: 2,
                        fill: `row`,
                    },
                    slidesPerView: 3,
                },
                768: {
                    grid: {
                        rows: 1,
                    },
                    slidesPerView: 4,
                    loop: true,
                },
                1024: {
                    grid: {
                        rows: 1,
                    },
                    loop: true,
                    slidesPerView: 5,
                    spaceBetween: 15,
                },
                1200: {
                    grid: {
                        rows: 1,
                    },
                    loop: true,
                    slidesPerView: 6,
                    spaceBetween: 30,
                }
            }
        });
    }
})();

// Action-derma slider
(function () {
    const actionSlider = document.querySelector(`.action-derma__slider`);

    if (actionSlider) {
        const slider = actionSlider.querySelector(`.swiper`);
        const buttonNext = actionSlider.querySelector(`.swiper__button--next`);
        const buttonPrev = actionSlider.querySelector(`.swiper__button--prev`);
        const pagination = actionSlider.querySelector(`.swiper-pagination`);

        const actionSwiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 15,
            speed: 500,
            effect: "fade",
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
            breakpoints: {
                1024: {
                    spaceBetween: 30,
                    speed: 500,
                }
            }
        });
    }
})();
